export default __webpack_public_path__ + "static/media/dashboard.875a3c3d.svg";